import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import loanFormModel from '../../form_models/loanFormModel';
import * as Yup from 'yup';
import IsOwnPropertyUnderConstructionRuleset from '../../business/ruleset/solar_property/IsOwnPropertyUnderConstructionRuleset';
import { defaultBorrowerLegalName } from '../../../../../../../components/loan_application/form_models/constants';

const { isOwnPropertyUnderConstruction } = loanFormModel.formField;

export class IsOwnPropertyUnderConstructionValidation
  implements ValidationSchema
{
  public name = isOwnPropertyUnderConstruction.name;
  public label = isOwnPropertyUnderConstruction.getLabel(
    '',
    defaultBorrowerLegalName
  );
  public type = 'string';

  public required = {
    message: '',
    value: false,
  };

  public nullable = true;
  public ruleset = IsOwnPropertyUnderConstructionRuleset;

  public when(schema: Yup.NumberSchema, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    if (required) return schema.required('This field is required');

    return schema;
  }
}
export default new Validation(new IsOwnPropertyUnderConstructionValidation());
